import React from "react";
import { I18n } from "react-redux-i18n";

interface IProps {
  width?: number;
  height?: number;
  title?: string;
}

export const Mastercard: React.FC<IProps> = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 5 24 14"
  >
    <title>{title || I18n.t("hoverIcons.mastercard")}</title>
    <g fill="none" fillRule="evenodd">
      <circle cx="7" cy="12" r="7" fill="#EA001B"/>
      <circle cx="17" cy="12" r="7" fill="#FFA200" fillOpacity=".8"/>
    </g>
  </svg>
);
